import React from 'react';

import SymbolWrapper from 'components/SideSymbol/SymbolWrapper';
import { DEFAULT_CURRENCY } from 'constants/globalConstants';

const CurrencySideSymbol = () => <SymbolWrapper>{DEFAULT_CURRENCY}</SymbolWrapper>;

export default CurrencySideSymbol;
